import React from "react";
import { useMediaQuery } from "@mui/material";

import DescriptionCard from "./cards/DescriptionCard";
import StatCard from "./cards/StatCard";
import useStats from "./hooks/useStats";

const Header = () => {
  const isMobile = useMediaQuery("(max-width:1218px)");
  const { unmappedLabProductsCount,unreviewedRecommendationsCount } = useStats();
  return (
    <header
      style={{
        ...baseStyles.header,
      }}
    >
      <DescriptionCard
        style={{ flex: isMobile ? "1 0 100%" : "1 0 50%" }}
        title="AI SKU Mapping"
        description="AI SKU Mapping suggests Dentira-equivalent matches for mapping to your Lab’s SKUs, which you can approve or reject."
      />

      <StatCard
        style={{
          flex: isMobile ? "1 0 10%" : "1 1 0",
          borderLeft: isMobile ? "none" : "1px solid #cecece",
        }}
        count={unreviewedRecommendationsCount}
        label="Unreviewed Suggestions"
      />

      <StatCard
        style={{
          flex: isMobile ? "1 0 10%" : "1 1 0",
          borderLeft: isMobile ? "none" : "1px solid #cecece",
        }}
        count={unmappedLabProductsCount}
        label="Unmapped Lab Products"
      />
    </header>
  );
};

const baseStyles = {
  header: {
    display: "flex",
    alignItems: "center",
    minHeight: "130px",
    height: "auto",
    borderBottom: "1px solid #cecece",
    flexWrap: "wrap",
  },
};

export default Header;
